/** Public site name shown in titles and social cards */
export const SITE_NAME = "Hoba Express";

/**
 * Meta description for key pages (aim ~100–130 chars for audit tools).
 * Longer positioning copy lives in SITE_DESCRIPTION_LONG and on-page content.
 */
export const SITE_TAGLINE =
  "Lease-to-own vehicles in Nigeria with Hoba Express: earn on your schedule and repay in simple, transparent installments.";

/** Richer description for JSON-LD and editorial use */
export const SITE_DESCRIPTION_LONG =
  "Hoba Express helps riders, drivers, and partners scale with lease-to-own vehicles, interstate parcel delivery, and mobility technology. We combine asset leasing, the Hoba Mobility platform, and on-demand services so individuals and businesses can move goods and people reliably across Nigeria and beyond.";

/**
 * Canonical origin for absolute URLs (Open Graph, sitemaps, JSON-LD).
 * Set REACT_APP_SITE_URL in production (e.g. https://hobaexpress.com) so
 * previews and canonicals stay correct even behind proxies or staging hosts.
 */
export const DEFAULT_SITE_ORIGIN = "https://hobaexpress.com";

/** Default document title length target ~50–60 chars for homepage shell */
export const DEFAULT_HOME_TITLE =
  "Hoba Express — Lease-to-own vehicles & mobility in Nigeria";

export function getSiteOrigin(): string {
  const fromEnv = process.env.REACT_APP_SITE_URL?.replace(/\/$/, "").trim();
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return DEFAULT_SITE_ORIGIN;
}

export function absoluteUrl(path: string): string {
  const origin = getSiteOrigin();
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${origin}${p}`;
}

/** Primary WhatsApp entry point (footer + floating action). */
export const SITE_WHATSAPP_URL =
  "https://wa.me/message/R4WMKGSJUWF2J1" as const;

/** Primary support phone (footer, hero CTA, tel: links). */
export const SITE_PHONE_DISPLAY = "+2349099843428" as const;
export const SITE_PHONE_TEL = `tel:${SITE_PHONE_DISPLAY}` as const;

/** Official social profiles (exact URLs for schema + footer; strengthens entity signals). */
export const SITE_SOCIAL_URLS = {
  instagram: "https://www.instagram.com/hobaexpress_?igsh=MTVmZ20zaDV4dzFwbw%3D%3D&utm_source=qr",
  facebook: "https://www.facebook.com/share/1FZ6T6SU9t/",
  linkedin: "https://www.linkedin.com/company/hobaexpress/",
  /** Company news and updates; update if your handle differs. */
  twitter: "https://x.com/hobaexpress",
  youtube: "https://www.youtube.com/@hobaexpress",
} as const;

/** Used in Organization JSON-LD `sameAs` */
export const SITE_SAME_AS: readonly string[] = [
  SITE_SOCIAL_URLS.linkedin,
  SITE_SOCIAL_URLS.twitter,
  SITE_SOCIAL_URLS.instagram,
  SITE_SOCIAL_URLS.facebook,
  SITE_SOCIAL_URLS.youtube,
];

/** Notable press coverage (linked from footer + optional structured data). */
export const SITE_PRESS_URLS = {
  vanguardLeaseToOwn2026:
    "https://www.vanguardngr.com/2026/02/hoba-express-strengthens-rider-ownership-through-lease-to-own-bike-scheme/",
} as const;

export const DEFAULT_OG_IMAGE_PATH = "/images/appLogo.png";
